import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderSlot as _renderSlot, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

import type { HTMLAttributes } from 'vue';
import { cn } from '@/lib/utils';


export default /*@__PURE__*/_defineComponent({
  __name: 'Table',
  props: {
    class: {},
    containerClass: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(_unref(cn)('relative max-w-full overflow-x-auto', props.containerClass))
  }, [
    _createElementVNode("table", {
      class: _normalizeClass(_unref(cn)('w-full min-w-full caption-bottom text-normal', props.class))
    }, [
      _renderSlot(_ctx.$slots, "default")
    ], 2)
  ], 2))
}
}

})